import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { KeyboardArrowRight } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import GenericFeaturePopup from './MapApp._GenericFeaturePopup';

const useStyles = makeStyles((theme) => ({
  sidebar: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 400,
    height: '100%',
    backgroundColor: 'white',
    boxShadow: '-2px 0 8px rgba(0,0,0,0.15)',
    transform: 'translateX(100%)',
    transition: 'transform 0.3s ease-in-out',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  sidebarOpen: {
    transform: 'translateX(0)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
  },
  title: {
    fontWeight: 600,
  },
  content: {
    overflowY: 'auto',
    flex: 1,
    padding: theme.spacing(2),
  },
}));

export default function MapFeatureSidebar({ open, onClose, features, layers, coordinates }) {
  const classes = useStyles();

  if (!open) return null;

  return (
    <div className={`${classes.sidebar} ${open ? classes.sidebarOpen : ''}`}>
      <div className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          Info på valgt
        </Typography>
        <IconButton onClick={onClose} size="small">
          <KeyboardArrowRight />
        </IconButton>
      </div>
      
      <div className={classes.content}>
        <GenericFeaturePopup features={features} layers={layers} />
      </div>
    </div>
  );
}
